export const RESET = 'GAME_LIST_RESET'
export const SET_ITEMS = 'GAME_LIST_SET_ITEMS'
export const SET_ALL_ITEMS = 'GAME_LIST_SET_ALL_ITEMS'
export const SET_ERROR = 'GAME_LIST_SET_ERROR'
export const SET_VIEW = 'GAME_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'GAME_LIST_TOGGLE_LOADING'
export const SET_LOADING = 'GAME_LIST_SET_LOADING'

export const SET_ITEM = 'GAME_LIST_SET_ITEM'
export const SET_ITEM_ACTIVE = 'GAME_LIST_SET_ITEM_ACTIVE'
export const SET_ITEM_ACTIVE_ERROR = 'GAME_LIST_SET_ITEM_ACTIVE_ERROR'
export const SET_ITEM_ACTIVE_LOADING = 'GAME_LIST_SET_ITEM_ACTIVE_LOADING'
